module.exports = __webpack_public_path__ + "static/media/mainzard.709d383b.jpg";